/**
 * Handles the syncing between the left pane and right pane in the modifier dialog
 */

export function ModifierGroupsDirective() {
    return {
        scope: false,
        link: function(scope) {
            scope.curModifierGroupId = null;

            scope.scrollToModifierGroup = function(modifierGroupId) {
                scope.scrollTo('modifierGroup-' + modifierGroupId);
                scope.setCurModifierGroup(modifierGroupId);
            };

            scope.setCurModifierGroup = function(modifierGroupId) {
                scope.curModifierGroupId = modifierGroupId;
            };

            /**
                 * isCurModifierGroup()
                 *  -> If the modifierGroup is currently selected
                 *  -> If the dialog is first opened, the first modifierGroup should be selected
                 * @param modifierGroupId
                 */
            scope.isCurModifierGroup = function(modifierGroupId) {
                return scope.curItem.modifierGroups[0].idString === modifierGroupId && scope.curModifierGroupId === null ||
                        scope.curModifierGroupId === modifierGroupId;
            };

            /**
                 * Watch for when the curItem goes null, meaning that the dialog was closed.
                 * We need reset the curModifierGroupId so that the first modifierGroup can be selected on the next open
                 */
            scope.$watch('curItem', function() {
                if (!scope.curItem) {
                    scope.curModifierGroupId = null;
                }
            });
        }
    };
}
